import React, { useState, useEffect } from 'react'
import { Button, Col, Container, Form, Modal, Row } from 'react-bootstrap'
import { useNavigate, useParams } from 'react-router-dom'
import axios from 'axios'
import Cookies from 'js-cookie'
import { theme } from '../theme/theme'
import { BASE_URL } from '../constants'


const UpdatePlot = () => {
  const { updateplotid } = useParams()
  const [plotData, setPlotData] = useState({
    plot_number: '',
    plot_size: '',
    price: '',
    status: 'SELECT',
    block: '',
    is_corner: 'SELECT',
  })
  const [showModal, setShowModal] = useState(false)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  // Fetch plot data when the component mounts
  useEffect(() => {
    const token = Cookies.get('authToken')
    if (!token) {
      setError('Authentication required. Please log in.')
      return
    }

    setLoading(true)
    axios
      .get(BASE_URL+`/get/plots?id=${updateplotid}`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        const data = response.data.data[0] // Get the first object from the data array
        console.log('Fetched plot data:', data)

        // Set plot data correctly from API response
        setPlotData({
          plot_number: data.plot_number || '',
          plot_size: data.plot_size || '',
          price: data.price || '',
          status: data.status || 'SELECT',
          block: data.block || '',
          is_corner: data.is_corner || 'SELECT',
        })
        setLoading(false)
      })
      .catch((err) => {
        console.error('Error fetching plot data:', err)
        setError('Failed to fetch plot data.')
        setLoading(false)
      })
  }, [updateplotid])

  // Handle form input changes
  const inputHandler = (e) => {
    const { name, value } = e.target
    setPlotData({ ...plotData, [name]: value })
  }

  // Handle form submission for updating plot
  const handleSubmit = (e) => {
    e.preventDefault()
    setLoading(true)

    if (plotData.status === 'SOLD') {
      setError('You are not allowed to mark a plot as "SOLD".')
      setLoading(false)
      return
    }

    const token = Cookies.get('authToken')
    if (!token) {
      setError('Authentication required. Please log in.')
      return
    }

    // Payload including the updated plot data
    const payload = {
      ...plotData,
      id: updateplotid, // Include plot ID for the update
    }

    axios
      .post(BASE_URL+`/plot/update`, payload, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        console.log('Plot updated successfully:', response.data)
        setShowModal(true)
        setTimeout(() => {
          navigate('/plotlists')
          window.location.reload()
        }, 3000)
      })
      .catch((err) => {
        if (err.response) {
          console.error('Error response:', err.response.data)
          setError(
            `Failed to update plot: ${
              err.response.data.message || 'Unknown error'
            }`,
          )
        } else {
          setError('Failed to update plot.')
        }
        setLoading(false)
      })
  }

  const handleModalClose = () => {
    setShowModal(false)
  }

  return (
<Container className="pb-3" style={{fontFamily: theme.font.family }}>

      <Form className="text-start rounded-3 m-0 px-3" onSubmit={handleSubmit} style={{backgroundColor: theme.colors.background}}>


  <p className="mb-4 fw-bold" style={{ color: theme.colors.primary, borderBottom: `2px solid ${theme.colors.secondary} `, paddingBottom: '8px' , fontSize: '1.5rem'}}>
    
          Update Plot
    </p>       

        <Row>
          <Col md={4} className="mb-3">
            <Form.Label htmlFor="plot_number">Plot Number</Form.Label>
            <Form.Control
              type="text"
              id="plot_number"
              name="plot_number"
              value={plotData.plot_number}
              placeholder={plotData.plot_number || 'Enter plot number'}
              onChange={inputHandler}
              disabled
            />
          </Col>
          <Col md={4} className="mb-3">
            <Form.Label htmlFor="plot_size">Plot Size</Form.Label>
            <Form.Control
              type="text"
              id="plot_size"
              name="plot_size"
              value={plotData.plot_size}
              placeholder={plotData.plot_size || 'Enter plot size'}
              onChange={inputHandler}
            />
          </Col>
          <Col md={4} className="mb-3">
            <Form.Label htmlFor="price">Price</Form.Label>
            <Form.Control
              type="text"
              id="price"
              name="price"
              value={plotData.price}
              placeholder={plotData.price || 'Enter price'}
              onChange={inputHandler}
            />
          </Col>
        </Row>

        <Row>
          <Col md={4} className="mb-3">
            <Form.Label htmlFor="status">Status</Form.Label>
            <Form.Select
              id="status"
              name="status"
              value={plotData.status}
              onChange={inputHandler}
            >
              <option value="SELECT">SELECT</option>
              <option value="AVAILABLE">AVAILABLE</option>
              <option value="SOLD">SOLD</option>
              <option value="HOLD">HOLD</option>
            </Form.Select>
          </Col>
          <Col md={4} className="mb-3">
            <Form.Label htmlFor="block">Block</Form.Label>
            <Form.Control
              type="text"
              id="block"
              name="block"
              value={plotData.block}
              placeholder={plotData.block || 'Enter block'}
              onChange={inputHandler}
            />
          </Col>
          <Col md={4} className="mb-3">
            <Form.Label htmlFor="is_corner">Is Corner</Form.Label>
            <Form.Select
              id="is_corner"
              name="is_corner"
              value={plotData.is_corner}
              onChange={inputHandler}
            >
              <option value="SELECT">SELECT</option>
              <option value="YES">YES</option>
              <option value="NO">NO</option>
            </Form.Select>
            {error && <p style={{ color: 'red' }}></p>}
          </Col>
        </Row>

        {error && <div className="alert alert-danger">{error}</div>}
        <div className="d-grid mt-4">
          <Button
            type="submit"
            className="text-white"
            style={{ backgroundColor: theme.colors.primary, border: 'none' }}
            disabled={loading}
          >
            {loading ? 'Updating...' : 'Update Plot'}
          </Button>
        </div>
      </Form>

      <Modal show={showModal} onHide={handleModalClose} centered>
        <Modal.Header closeButton>
          <Modal.Title className="w-100 text-center">
            Plot Updated Successfully!
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            You can now view their details or proceed with the next steps in the
            process.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button style={{backgroundColor: theme.colors.primary, color:theme.colors.background, border:'none'}} onClick={handleModalClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  )
}

export default UpdatePlot
